import FactList from './FactList';

export default FactList;